<template>
  <div class="load-hide">
    <div class="context card_bind_context">
      <div class="top-context-parent">
        <div class="top-context">
          <div class="top-from">
            <div class="btop_tip">请输入您的会员卡号</div>
            <div class="button-one card-in">
              <div class="in_tip">卡号</div>
              <input v-model="card_num" type="text" class="">
            </div>
            <div class="btop_tip">请输入您的手机号码</div>
            <div class="button-two phone-in">
              <div class="in_tip">手机号</div>
              <input v-model="cust_mobile" type="text">
            </div>
            <div class="btop_tip">请点击“获取验证码”按钮，填写您收到的验证码</div>
            <div class="button-three " >
              <div class="in_tip">验证码</div>
              <input type="text" v-model="card_bind_vcode" class="input-text">
              <div v-if="!sendMsgDisabled" class="button-four" @click="getSession">
                <a  class="get-start">获取验证码<br/></a>
              </div>
              <div v-if="sendMsgDisabled" class="button-four">
                <a class="waitTime">{{time+'秒'}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="next-button">
        <input type="button" value="绑定" class="bangding" @click="bindup">
      </div>
    </div>
    <div class="success hdiv" >
      <div class="cover"></div>
      <div class="cover-content">
        <!--<img src="http://style.cdn.juhaomai.net/style/game/huiyuanbangding/images/v2/success.png">-->
        <div class="success-text">
          <p>绑定成功</p>
          <input type="button" value="确定" @click="goQrcode">
        </div>
      </div>
    </div>
    <div class="fail hdiv"  >
    <div class="cover"></div>
    <div class="cover-content">
      <img src="http://style.cdn.juhaomai.net/style/game/huiyuanbangding/images/v2/sorry.png">
      <div class="fail-text">
        <p>{{err_msg}}</p>
        <p></p>
        <input type="button" value="确定" @click="closeAgain">
      </div>
    </div>
  </div>
    <div class="again hdiv" >
      <div class="cover"></div>
      <div class="cover-content">
        <img src="http://style.cdn.juhaomai.net/style/game/huiyuanbangding/images/v2/again.png">
        <div class="again-text">
          <input type="button" value="电话告诉我验证码"  >
          <input type="button" value="取消" class="pass" @click="closePhone">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import auth from '../../../lib/auth';
import constants from '../../../lib/constants';
export default {
  data(){
      return{
        mid:"123",
        store_id:"",
        cb_url:encodeURIComponent(location.href),
        card_num:"",
        cust_mobile:"",
        card_bind_vcode:"",
        err_msg:"",
        time: 60, // 发送验证码倒计时
        sendMsgDisabled: false,
      }
  },
  mounted(){

  },
  methods: {

      //取消绑定 跳转至个人中心页面
    goBack(){
      location.href = location.href;
    },
    goQrcode(){
        router.push("/card_qrcode");
    },
    //关闭电联弹框
    closePhone(){
      $(".again").hide();_
    },
    closeAgain(){
      router.push("/card_qrcode");
    },
    //获取短信码
    getSession(){
      var numREG = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
      if(!this.card_num || !this.cust_mobile){
            alert("请输入会员卡号和手机号!")
      }else if(!numREG.test(this.cust_mobile)){
            alert("请输入正确的手机号码!")
      }else{
//        alert(constants.API_HOST + constants.API_BIND_CARD_PRO);
          this.$http.post(constants.API_HOST + constants.API_BIND_CARD_PRO, {
            "card_num":this.card_num,
            "cust_mobile":this.cust_mobile,
            "card_type":"fcard"
          }).then((result) => {
            let data = result.data;
            console.log(data,8797);
//            this.$alert(data.data);
            if (data.code === "200") {
              //发送成功，60s后可再发送
              this.send();
//              this.$alert(data.data);
            }else if(data.code === "641"){
              this.err_msg = data.data;
              $(".fail").show();
//              location.href="/main.html#/card_qrcode";
            } else {
              this.$alert(data.data);
            }
          }, (error) => {
//            error.data && this.$alert(error.data);
          });
        }
    },
    send() {
      let me = this;
      me.sendMsgDisabled = true;
      let interval = window.setInterval(function() {
        if ((me.time--) <= 0) {
          me.time = 60;
          me.sendMsgDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    //绑定会员卡
    bindup(){
      if(!this.card_bind_vcode){
        alert("请输入短信验证码")
      }else{
        $('.bangding').attr('disabled',"true");
        this.$http.post(constants.API_HOST + constants.API_BIND_CARD_FIN, {
          "card_num":this.card_num,
          "cust_mobile":this.cust_mobile,
          "card_bind_vcode":this.card_bind_vcode,
        }).then((result) => {
          let data = result.data;
          if (data.code === "200") {
            $(".success").show()
          } else {
            this.$alert(data.data);
            $('.bangding').removeAttr("disabled"); //移除disabled属性
          }
        }, (error) => {
          error.data && this.$alert(error.data);
          $('.bangding').removeAttr("disabled"); //移除disabled属性
        });
      }
    },
  }

}

function getQueryString(key){
  var reg = new RegExp("(^|&)"+key+"=([^&]*)(&|$)");
  var result = window.location.search.substr(1).match(reg);
  return result?decodeURIComponent(result[2]):null;
}
</script>

<style>

  body,html{
    height:100%;
  }
  html {
    font-size:90px!important
  }
  @media only screen and (min-width:319px) {
    html {
      font-size:100px!important
    }
  }@media only screen and (min-width:370px) {
    html {
      font-size:117px!important
    }
  }@media only screen and (min-width:414px) {
    html {
      font-size:129px!important
    }
  }
  @media only screen and (min-width:639px) {
    html {
      font-size:200px!important
    }
  }
  .load-hide{
    height: 100%;
    background-color: #fff;
  }
  .card_bind_context{
    background: #eff3f6;
    background-size: cover;
    text-align: center;
    height:100%;
    overflow: hidden;
    position: relative;
  }
  .top-context-parent{
    width: auto;
    overflow: hidden;
  }
  .top-context{
    display: block;
    margin: 0;
    width: auto;
    margin: 0 auto;
    height: auto;
    background-image: none;
    background-size: cover;
    background-repeat: no-repeat;
    background-size: 285px 290px;
  }
  .button-one,.button-two,.button-three{
    background: #fff;
    display: flex;
  }
  .in_tip{
    color:#000000;
    height:0.43rem;
    line-height: 0.43rem;
    min-width: 20%;
    text-align: left;
    padding-left: 0.15rem;
    font-size:0.14rem;
  }
  .btop_tip{
    width: 100%;
    height: 0.35rem;
    line-height: 0.35rem;
    text-align: left;
    padding-left: 0.15rem;
    color: #888888;
    font-size: 0.12rem;
  }
  .button-one span{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_vip.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 13.5px;
    height: 8.5px;
    display: inline-block;
  }
  .button-one,.button-two{
    width: 100%;
    margin-bottom: 10px;
  }
  .button-three{
    margin-right: 10px;
    float: left;
    width: 100%;
    margin-bottom: 10px;
    position: relative;
  }
  .top-from{
    font-size: 13px;
    width: 100%;
    margin: 0px auto;
    padding-top: 0px;
  }
  .top-from input{
    background: transparent;
    border: 0;
    color: #000000;
    height: 0.43rem;
    line-height: 0.43rem;
    margin-left: 15px;
  }
  .button-two span{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_phone.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 10px;
    height: 13.5px;
    display: inline-block;
  }
  .button-three span{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_shilden.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 10px;
    height: 12px;
    display: inline-block;
  }
  .button-four{
    padding-right: 0.085rem;
    min-width: 25%;
    height:0.43rem;
    line-height: 0.43rem;
  }
  .button-four .get-start{
    display: block;
    width: 100%;
    height:0.3rem;
    line-height: 0.3rem;
    color: #1aad19;
    background-color: #fff;
    letter-spacing: 0;
    font-size: 0.12rem;
    border: 1px solid #1aad19;
    border-radius: 5px;
    text-align: center;
    margin-top: 0.07rem;
  }
  .next-button{
    position: fixed;
    bottom:3%;
    left:5%;
    width:90%;
  }
  .next-button input{
    height: 0.44rem;
    width: 100%;
    display: block;
    border: 0;
    font-size: 0.14rem;
    color: #fff;
    border-radius: 8px;
  }
  .bangding{
    background-color: #3d9946;
    color: #fff;
    margin-right: 10px;
  }
  .qvxiao{
    background-color: #fff;
    color: #50a200 !important;
    border: 1px solid #50a200 !important;
  }
  .waitTime{
    display: block;
    width: 100%;
    height:0.3rem;
    line-height: 0.3rem;
    color: #fff;
    background-color: #a6a6a6;
    letter-spacing: 0;
    font-size: 0.12rem;
    border-radius: 5px;
    text-align: center;
    margin-top: 0.07rem;
  }
  /*遮罩*/
  .cover{
    display: block;
    width: 100%;
    height: 100% !important;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 8888;
    background-color: #000000;
    opacity: 0.8;
  }
  .cover-content{
    z-index: 9999;
    position: absolute;
    left: 13%;
    top: 30%;
  }
  .success{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }
  .success img{
    width: 247px;
  }
  .success-text{
    position: absolute;
    top: 40%;
    width: 100%;
    left: 0;
    text-align: center;
    font-family: "\5FAE\8F6F\96C5\9ED1";
    font-size: 12px;
    width: 2.4rem;
    background: #fff;
    padding: 0.2rem;
  }
  .success-text p{
    margin-bottom: 3%;
    font-size: 0.16rem;
  }
  .success-text input{
    height: 35px;
    border: 0px;
    background: #3d9946;
    color: #fff;
    font-size: 18px;
    letter-spacing: 3px;
    margin-top: 2%;
    width:70%;
    border-radius: 8px;
  }
  .fail{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }
  .fail img{
    width: 247px;
  }
  .fail-text{
    position: absolute;
    top: 40%;
    width: 100%;
    left: 0;
    text-align: center;
    font-family: "微软雅黑";
    font-size: 12px;
  }
  .fail-text p{
    margin-bottom: 3%;
  }
  .fail-text input{
    height: 35px;
    border: 0px;
    background: #50A200;
    color: #fff;
    font-size: 18px;
    letter-spacing: 3px;
    margin-top: 2%;
    width:70%;
  }
  .again{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }
  .again img{
    width: 247px;
  }
  .again-text{
    position: absolute;
    top: 40%;
    width: 100%;
    height: 100%;
    left: 0;
    text-align: center;
    font-family: "微软雅黑";
    font-size: 12px;
  }
  .again-text .pass{
    background:#356500 ;
    margin-top: 10px;
    letter-spacing: 3px;
  }
  .again input{
    height: 35px;
    border: 0px;
    background: #50A200;
    color: #fff;
    font-size: 18px;
    letter-spacing: 1px;
    margin-top: 2%;
    width: 70%;
  }

</style>



// WEBPACK FOOTER //
// card_bind.vue?47ce8490